import {
  INITIAL_COLUMNS_STATE,
  INITIAL_LISTINGTYPENAMES_STATE,
  INITIAL_UX_STATE,
  INITIAL_REVIEWS_STATE,
} from "./Toolbar/utils";

export const CxStoreSlice = (set) => ({
  cxSearch: "",
  cxOwners: [],
  cxDomains: [],
  cxSelectedOwners: [],
  cxSelectedDomains: [],
  cxListingtypenames: INITIAL_LISTINGTYPENAMES_STATE,
  cxSelectedChannels: [],
  cxSelectedBrand: null,
  cxSelectedCategoryPath: null,
  cxSelectedReviews: INITIAL_REVIEWS_STATE,
  cxSelectedUX: INITIAL_UX_STATE,
  cxSelectedListingtypename: "Todas",
  cxSelectedListingtypenameId: 0,
  cxColumns: INITIAL_COLUMNS_STATE,
  cxShowCard: true,
  cxRows: [],
  cxShowInactive: true,
  cxRowsSelectionModel: [],
  cxEditedRows: {},
  openCxCostHistoryModal: null,
  cxShowFlag: false,
  cxTableCustomizationTooltip: false,
  paginationModelCX: {
    page: 0,
    pageSize: 10,
  },

  setCxOwners: (owners) => set(() => ({ cxOwners: owners })),
  setCxDomains: (domains) => set(() => ({ cxDomains: domains })),

  toggleCxShowFlag: () =>
    set((state) => ({
      cxShowFlag: !state.cxShowFlag,
    })),
  setCxShowFlag: (value) => set(() => ({ cxShowFlag: value })),

  setCxSearch: (search) => set(() => ({ cxSearch: search })),

  toggleCxSelectedOwners: (owner) =>
    set((state) => {
      const isSelected = state.cxSelectedOwners.includes(owner);
      const cxSelectedOwners = isSelected
        ? state.cxSelectedOwners.filter((o) => o !== owner)
        : [...state.cxSelectedOwners, owner];
      return { cxSelectedOwners };
    }),
  setCxSelectedOwners: (owner) => set(() => ({ cxSelectedOwners: owner })),

  setCxSelectedReviews: (review) => set(() => ({ cxSelectedReviews: review })),

  setCxSelectedUX: (review) => set(() => ({ cxSelectedUX: review })),

  clearCxSelectedOwners: () => set(() => ({ cxSelectedOwners: [] })),

  toggleCxSelectedDomains: (domain) =>
    set((state) => {
      const isSelected = state.cxSelectedDomains.includes(domain);
      const cxSelectedDomains = isSelected
        ? state.cxSelectedDomains.filter((d) => d !== domain)
        : [...state.cxSelectedDomains, domain];
      return { cxSelectedDomains };
    }),
  clearCxSelectedDomains: () => set(() => ({ cxSelectedDomains: [] })),
  clearCxSelectedChannels: () =>
    set(() => ({
      cxSelectedChannels: [],
    })),

  setCxSelectedChannels: (channelsArray) =>
    set((state) => {
      const cxShowFlag = channelsArray === "VTEX" ? false : state.cxShowFlag;
      const cxListingtypename = channelsArray.includes("MELI")
        ? state.cxSelectedListingtypename
        : "Todas";
      const cxListingtypenameId = channelsArray.includes("MELI")
        ? state.cxSelectedListingtypenameId
        : 0;
      return {
        cxShowFlag,
        cxSelectedChannels: channelsArray,
        cxSelectedListingtypename: cxListingtypename,
        cxSelectedListingtypenameId: cxListingtypenameId,
      };
    }),
  setCxSelectedListingtypename: (listingtypename, id) =>
    set(() => ({
      cxSelectedListingtypename: listingtypename,
      cxSelectedListingtypenameId: id,
    })),

  clearCxSelectedListingtypename: () =>
    set(() => ({
      cxSelectedListingtypename: "Todas",
      cxSelectedListingtypenameId: 0,
    })),
  setCxSelectedBrand: (brand) =>
    set((state) => {
      const newBrand = state.cxSelectedBrand === brand ? null : brand;
      return {
        cxSelectedBrand: newBrand,
      };
    }),
  clearCxSelectedBrand: () =>
    set(() => ({
      cxSelectedBrand: null,
    })),
  setCxSelectedCategoryPath: (categoryPath) =>
    set((state) => {
      const newCategoryPath =
        state.cxSelectedCategoryPath === categoryPath ? null : categoryPath;
      return {
        cxSelectedCategoryPath: newCategoryPath,
      };
    }),
  clearCxSelectedCategoryPath: () =>
    set(() => ({
      cxSelectedCategoryPath: null,
    })),

  toggleCxColumns: (field, value) =>
    set((state) => ({
      cxColumns: {
        ...state.cxColumns,
        [field]: value,
      },
    })),
  resetCxColumns: () =>
    set(() => ({
      cxColumns: INITIAL_COLUMNS_STATE,
    })),
  toggleCxShowInactive: () =>
    set((state) => ({ cxShowInactive: !state.cxShowInactive })),
  setCxShowInactive: (paused) => set((state) => ({ cxShowInactive: paused })),

  updateCxRowsSelectionModelAndEditedRows: (model) =>
    set((state) => ({ cxRowsSelectionModel: model })),
  setCxRows: (rows) => set({ cxRows: rows }),

  toggleCxRowSelected: (rowId) =>
    set((state) => {
      const selected = state.cxRowsSelectionModel;
      return selected.includes(rowId)
        ? { cxRowsSelectionModel: selected.filter((id) => id !== rowId) } // quitar
        : { cxRowsSelectionModel: [...selected, rowId] }; // agregar
    }),
  setAllCxEditedRows: (newEditedRows) => set({ cxEditedRows: newEditedRows }),
  toggleCxEditedRow: (rowId) =>
    set((state) => {
      const newEditedRows = { ...state.cxEditedRows };
      if (newEditedRows[rowId]) {
        delete newEditedRows[rowId]; // elimina si estaba seleccionado
      } else {
        newEditedRows[rowId] = true;
      }
      return { cxEditedRows: newEditedRows };
    }),
  toggleCxShowCard: () => set((state) => ({ cxShowCard: !state.cxShowCard })),

  toggleCxTableCustomizationTooltip: () =>
    set((state) => ({
      cxTableCustomizationTooltip: !state.cxTableCustomizationTooltip,
    })),

  openCxTableCustomizationTooltip: () =>
    set(() => ({
      cxTableCustomizationTooltip: true,
    })),

  closeCxTableCustomizationTooltip: () =>
    set(() => ({
      cxTableCustomizationTooltip: false,
    })),
  setPaginationModelCX: (model) => set({ paginationModelCX: model }),
  cxClearFilters: () =>
    set(() => ({
      cxSelectedChannels: [],
      paginationModelCX: {
        page: 0,
        pageSize: 10,
      },
    })),
});
